<template>
  <div class="one-column-width">
    <v-card class="r_tabsform_card">
      <v-card-title class="r_form_card_title ext_pdg_to_lvl"> Edit Listing </v-card-title>
      <hr class="r_form_card_top_hr">

      <div>
        <v-form ref="form" @submit.prevent="submit" class="">
          <v-container fluid>
            <v-col cols="12" sm="12">
              <v-row>
                <v-text-field
                  v-model="title"
                  :rules="rules.title"
                  color="purple name-2"
                  class="r_formtabs_inputs col-7"
                  label="Listing Name"
                  required
                  style="width: 100%; max-width: 100% !important"
                ></v-text-field>

                <v-autocomplete
                  v-model="campus_id"
                  :rules="rules.campus_id"
                  :items="campusesData"
                  item-text="text"
                  item-value="value"
                  class="r_formtabs_inputs col-7"
                  label="Select Campus"
                  @change="filterDepartment($event)"
                ></v-autocomplete>
                <v-autocomplete
                  v-model="department_id"
                  :rules="rules.department_id"
                  :items="departmentsData"
                  item-text="text"
                  item-value="value"
                  class="r_formtabs_inputs col-7"
                  label="Select Department"
                  @change="filterProgram($event)"
                ></v-autocomplete>
                <v-autocomplete
                  v-model="program_id"
                  :rules="rules.program_id"
                  :items="programsData"
                  item-text="text"
                  item-value="value"
                  class="r_formtabs_inputs col-7"
                  label="Select Program"
                ></v-autocomplete>

                <v-autocomplete
                  v-model="firstLevelCategory"
                  :items="firstLevelCategoriesData"
                  item-text="text"
                  item-value="value"
                  class="r_formtabs_inputs col-7"
                  label="First Level category"
                  @change="filterSecondLevelCatigories($event)"
                ></v-autocomplete>
                <v-autocomplete
                  v-model="secondLevelCategory"
                  :items="secondLevelCategories"
                  item-text="text"
                  item-value="value"
                  class="r_formtabs_inputs col-7"
                  label="Second Level category"
                  @change="filterCatigories($event)"
                ></v-autocomplete>
                <v-autocomplete
                  v-model="category_id"
                  :rules="rules.category_id"
                  :items="Categories"
                  item-text="text"
                  item-value="value"
                  class="r_formtabs_inputs col-7"
                  label="Main categories"
                ></v-autocomplete>

                <div class="r_formtabs_editor_input col-7 mb-5">
                  <vue-editor
                    v-model="eligibility_criteria"
                    outlined
                    name="input-7-4"
                    label="About"
                    rows="3"
                    placeholder="Eligibility Criteria"
                  ></vue-editor>
                </div>

                <!-- <div class="row" style="margin-top: 2%"> -->
                <div class="r_formtabs_editor_input col-7 mb-5">
                  <vue-editor
                    v-model="description"
                    outlined
                    name="input-7-4"
                    label="About"
                    rows="3"
                  ></vue-editor>
                </div>
                <!-- </div> -->
                <div class="col-1"></div>

                <div class="col-3 mb-5">
                  <img
                    style="border-radius: 8px; width: 126px; height: 126px; object-fit: cover;"
                    :src="url || placeholderImage"
                    @error="$event.target.src = placeholderImage"
                  />
                  <v-file-input
                    style="font-size: 8px"
                    class="r_formtabs_inputs col-7"
                    label="Main Banner"
                    @change="Preview_image"
                    v-model="image"
                    :rules="rules.image"
                  >
                  </v-file-input>
                </div>
                <div class="col-md-3">
                  <img
                    style="border-radius: 8px; width: 126px; height: 126px; object-fit: cover;"
                    :src="url2 || placeholderImage"
                    @error="$event.target.src = placeholderImage"
                  />
                  <v-file-input
                    style="font-size: 8px"
                    class="r_formtabs_inputs col-7"
                    label="Second Image"
                    @change="Preview_image_2"
                    v-model="image2"
                  >
                  </v-file-input>
                </div>
                <div class="col-md-3">
                  <v-file-input
                    style="font-size: 8px; margin-top: 130px"
                    class="r_formtabs_inputs col-7"
                    label="Brochure"
                    @change="pdf()"
                    v-model="brochure"
                  >
                  </v-file-input>
                </div>
                <div class="col-md-3">
                  <v-autocomplete
                    v-model="admission_form_id"
                    :items="admissionForms"
                    class="r_formtabs_inputs col-7"
                    label="Admission Form"
                    style="margin-top: 130px"
                  ></v-autocomplete>
                </div>
                <!-- <template v-if="!editId">
                  <v-btn
                    class="custom-add-new-record-button"
                    type="button"
                    @click="addNewRow()"
                    >+</v-btn
                  >
                  <v-btn
                    v-if="index > 0"
                    class="custom-delete-new-record-button"
                    type="button"
                    @click="deleteRow(index)"
                    >-</v-btn
                  >
                </template> -->
              </v-row>
            </v-col>
          </v-container>
          <v-card-actions>
            <button class="r_form_add_more_btnnn" type="submit"
              ><b-spinner small type="grow" v-if="submitting"></b-spinner>
              <span v-if="!editId">Submit</span>
              <span v-if="editId">Update</span>
            </button>
            <button type="button" @click="cancelForm" class="r_form_cancel_more_btnnn"
              >Cancel</button
            >
          </v-card-actions>
        </v-form>
      </div>
    </v-card>
  </div>
</template>

<script>
import ProgramService from "@/MainServices/ProgramService.js";
import SubjectService from "@/MainServices/SubjectService.js";
import ListingService from "@/MainServices/ListingService.js";
import CategoryService from "@/MainServices/CategoryService.js";
import { VueEditor } from "vue2-editor";
import API from "@/core/api";

import { required, minLength } from "vuelidate/lib/validators";
export default {
  data() {
    return {
        api: API.API_HOME,
      title: "",
      campus_id: null,
      department_id: null,
      program_id: null,
      category_id: null,
      firstLevelCategory: null,
      secondLevelCategory: null,
      image: null,
      image2: null,
      brochure: null,
      admission_form_id: null,
      description: null,
      eligibility_criteria: null,
      campusesData: [],
      departmentsData: [],
      programsData: [],
      departments: [],
      programs: [],
      admissionForms: [],
      url: "",
      url2: "",
      placeholderImage: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='200' viewBox='0 0 200 200'%3E%3Crect fill='%23f0f0f0' width='200' height='200'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' font-family='Arial' font-size='14' fill='%23999'%3ENo Image%3C/text%3E%3C/svg%3E",

      firstLevelCategoriesData: [],
      secondLevelCategoriesData: [],
      CategoriesData: [],
      secondLevelCategories: [],
      Categories: [],
      editId: null,
      deleteId: null,
      dialog: false,
      rules: {
        title: [(val) => (val || "").length > 0 || "Title is required"],
        campus_id: [(val) => !!val || "Campus is required"],
        department_id: [(val) => !!val || "Department is required"],
        program_id: [(val) => !!val || "Program is required"],
        category_id: [(val) => !!val || "Category is required"],
        image: [(val) => !!val || "Image is required"],
        description: [
          (val) => (val || "").length > 0 || "Description is required",
        ],
        eligibility_criteria: [(val) => (val || "").length > 0 || "Eligibility criteria is required"],
      },
      snackbar: false,
      snackBarText: null,
      submitting: false,
      deleting: false,
      errorMessage: false,
      search: "",
      showFormData: false,
      headers: [
        {
          text: "Campus",
          align: "left",
          sortable: false,
          value: "campus",
          width: "20%",
        },
        {
          text: "Department",
          align: "left",
          sortable: false,
          value: "department",
          width: "18%",
        },

        {
          text: "Program",
          align: "left",
          sortable: false,
          value: "program",
          width: "15%",
        },
        {
          text: "Title",
          align: "left",
          sortable: false,
          value: "title",
          width: "20%",
        },
        {
          text: "Plan",
          align: "left",
          sortable: false,
          value: "stripe_plan",
          width: "10%",
        },
        { text: "Actions", value: "actions", sortable: false },
      ],
      tableData: [],
      data: JSON.parse(localStorage.getItem("listing")),
    };
  },
  validations: {
    form: {
      required,
      $each: {
        title: { minLength: minLength(1), required },
        campus_id: { minLength: minLength(1), required },
        department_id: { minLength: minLength(1), required },
        program_id: { minLength: minLength(1), required },
        category_id: { minLength: minLength(1), required },
        image: { minLength: minLength(1), required },
        description: { minLength: minLength(1), required },
        eligibility_criteria: { minLength: minLength(1), required },
      },
    },
  },
  components: {
    VueEditor,
  },

  computed: {},

  methods: {
    getInititalData() {
      // console.log(this.$route.params.item);
      // const { title, campus } = this.data;

      
      this.category_id = this.data?.categories?.[0]?.id
      this.secondLevelCategory = this.data?.categories?.[0]?.second_level_categories_id;


      
      ListingService.getInstituteListings()
        .then((res) => {
          this.tableData = res?.data;
          this.title = this.data?.title;
          // this.campus_id = campus;

        })

        .catch(() => {
          this.loading = false;
        });

      if (this.secondLevelCategory) {
        CategoryService.getSecondLevelCategory(this.secondLevelCategory)
          .then((res) => {
            
            this.firstLevelCategory = res.data.first_level_categories_id;
            this.filterSecondLevelCatigories(this.firstLevelCategory);
            this.filterCatigories(this.secondLevelCategory);

          })

          .catch(() => {
            this.loading = false;
          });
      }
    },
    // main methods
    Preview_image() {
      this.url = URL.createObjectURL(this.image);
    },
    Preview_image_2() {
      this.url2 = URL.createObjectURL(this.image2);
    },

    filterDepartment(id) {
      this.departments = this.departmentsData.filter((el) => {
        return el.campus_id == Number(id);
      });
    },
    filterProgram(id) {
      this.programs = this.programsData.filter((el) => {
        return el.department_id == Number(id);
      });
    },
    filterSecondLevelCatigories(id) {
      
      this.secondLevelCategories = this.secondLevelCategoriesData.filter(
        (el) => {
          return el.parentId == Number(id);
        }
      );
    },
    filterCatigories(id) {
      this.Categories = this.CategoriesData.filter((el) => {
        return el.parentId == Number(id);
      });
    },
    redirectToAddListing() {
      this.$router.push("/institute/add-listing");
    },
    showForm() {
      this.editId = null;
      this.showFormData = true;
      this.resetForm();
    },
    showEditForm(item) {
      this.form = [{ name: item.subject, program_id: item.program_id }];
      this.editId = item.id;
      this.showFormData = true;
    },
    cancelForm() {
      this.resetForm();

      this.showFormData = false;

      this.$router.push("/institute/listings");
    },
    resetForm() {
      this.form = [{ city: "", country_id: null }];
      this.editId = null;
      setTimeout(() => {
        if (this.$refs.form) {
          this.$refs.form.reset();
        }
      }, 100);
    },
    addNewRow() {
      this.form.push({ city: "", country_id: null });
    },
    deleteRow(index) {
      this.form.splice(index, 1);
    },
    submit() {
      this.submitting = true;
      let formData = new FormData();
      formData.append("title", this.title);
      formData.append("listing_id", this.data.id);
      formData.append("campus_id", this.campus_id);
      formData.append("department_id", this.department_id);
      formData.append("program_id", this.program_id);
      formData.append("category_id", this.category_id);
      formData.append("image", this.image);
      formData.append("image2", this.image2);
      formData.append("brochure", this.brochure);
      formData.append("admission_form_id", this.admission_form_id);
      formData.append("description", this.description);
      formData.append("eligibility_criteria", this.eligibility_criteria);

      ListingService.updateNewListing(formData)
        .then((res) => {
          this.resetForm();
          this.getInititalData();
          this.submitting = false;
          this.snackBarText = "New listing Added!";
          this.snackbar = true;
          this.$router.push("/institute/listings");
        })
        .catch((error) => {
          this.errorMessage = true;
        });

      // if (this.editId) {
      //   SubjectService.editSubject(this.form, this.editId)
      //     .then((res) => {
      //       this.resetForm();
      //       this.getInititalData();
      //       this.submitting = false;
      //       this.snackBarText = "City Updated successful!";
      //       this.snackbar = true;
      //     })
      //     .catch((error) => {
      //       this.errorMessage = true;
      //     });
      // } else {
      //   SubjectService.addNewSubjects(this.form)
      //     .then((res) => {
      //       this.resetForm();
      //       this.getInititalData();
      //       this.submitting = false;
      //       this.snackBarText = "Subject Added successful!";
      //       this.snackbar = true;
      //     })
      //     .catch((error) => {
      //       this.errorMessage = true;
      //     });
      // }
    },
    askUserAboutDelete(item) {
      this.deleteId = item.id;
      this.dialog = true;
    },
    deleteItem() {
      this.deleting = true;
      SubjectService.deleteSubject(this.deleteId)
        .then((res) => {
          this.editId = null;
          this.deleting = false;
          this.dialog = false;
          this.resetForm();
          this.getInititalData();
          this.snackBarText = "Subject Deleted successful!";
          this.snackbar = true;
        })
        .catch((error) => {
          this.errorMessage = true;
          this.dialog = false;
        });
    },
  },
  mounted() {
    // Check if data exists, if not redirect back
    if (!this.data) {
      this.$router.push("/institute/listings");
      return;
    }

    // Set listing data first
    this.title = this.data?.title;
    this.description = this.data?.description;
    this.eligibility_criteria = this.data?.eligibility_criteria;
    this.url = this.data?.images?.[0]?.image_path ? this.api+'/storage/'+this.data.images[0].image_path : '';
    this.url2 = this.data?.images?.[1]?.image_path ? this.api+'/storage/'+this.data.images[1].image_path : '';
    
    // Fetch all required data
    Promise.all([
      ProgramService.getInstitutePrograms(),
      CategoryService.getFirstLevelCategories(),
      CategoryService.getSecondLevelCategories(),
      CategoryService.getCategories()
    ]).then(([programRes, firstLevelRes, secondLevelRes, categoriesRes]) => {
      // Populate campuses, departments, and programs
      programRes.data.map((el) => {
        this.campusesData.push({ value: el.id, text: el.name });
        el.departments.map((el2) => {
          this.departmentsData.push({
            value: el2.id,
            text: el2.department,
            campus_id: el.id,
          });
          el2.programs.map((el3) => {
            this.programsData.push({
              value: el3.id,
              text: el3.program,
              department_id: el3.department_id,
            });
          });
        });
      });

      // Set pre-populated values from listing data
      if (this.data?.campus_id) {
        this.campus_id = this.data.campus_id;
      } else if (this.data?.campus) {
        const campus = programRes.data.find(el => el.name == this.data.campus);
        if (campus) this.campus_id = campus.id;
      }

      if (this.data?.department_id) {
        this.department_id = this.data.department_id;
      } else if (this.data?.department) {
        const dept = this.departmentsData.find(el => el.text == this.data.department);
        if (dept) this.department_id = dept.value;
      }

      if (this.data?.program_id) {
        this.program_id = this.data.program_id;
      } else if (this.data?.program) {
        const prog = this.programsData.find(el => el.text == this.data.program);
        if (prog) this.program_id = prog.value;
      }

      // Populate first level categories
      firstLevelRes.data.map((el) => {
        this.firstLevelCategoriesData.push({
          value: el.id,
          text: el.category,
        });
      });

      // Populate second level categories
      secondLevelRes.data.map((el) => {
        this.secondLevelCategoriesData.push({
          value: el.id,
          text: el.category,
          parentId: el.first_level_categories_id,
        });
      });

      // Populate main categories
      categoriesRes.data.map((el) => {
        this.CategoriesData.push({
          value: el.id,
          text: el.category,
          parentId: el.second_level_categories_id,
        });
      });

      // Now get initial category data
      this.getInititalData();
    })
    .catch((e) => {
      this.loading = false;
    });
  },
};
</script>
